// extracted by mini-css-extract-plugin
module.exports = {"title":"PdpSharedBlurbs__title__dd4a5532","tradeLoyalty":"PdpSharedBlurbs__tradeLoyalty__dd4a5532","pcsDivider":"PdpSharedBlurbs__pcsDivider__dd4a5532"};